// Central brand + contact details for Cohnect LLC.
// Single source of truth used across footer, contact page, and legal pages.
export const BRAND = {
  entity: "Cohnect LLC",
  email: "info@cohnect.net",
  emailHref: "mailto:info@cohnect.net",
  phone: "+1 941-646-6999",
  phoneHref: "tel:+19416466999",
  address: {
    line1: "7901 4th St N #13824",
    line2: "St Petersburg, FL 33702",
    country: "United States (Pinellas County)",
  },
  discordInviteUrl: "https://discord.gg/cohnect",
  kofiUrl: "https://ko-fi.com/cohnect",
};
